import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { Spacer, Heading, Text, Box } from '@zillow/constellation';
import { getCommaSeparatedNumber } from '../../utils/zhl-calculator.js';
import { useLastValidDTIValues, getDefaultMortgagePayment } from './DTICalculator.utils.js';
import DTIMessage from './DTIMessage.js';
import DTISlider from './DTISlider.js';
import DTICostBreakdownTable from './DTICostBreakdownTable.js';

var DTIOutputTable = function DTIOutputTable() {
  var form = useFormContext();
  var lastValidValues = useLastValidDTIValues(form);
  var debtsOut = lastValidValues.calculations.debtsOut;
  var monthlyIncome = lastValidValues.calculations.monthlyIncome;
  var _useState = useState(getDefaultMortgagePayment(debtsOut, monthlyIncome)),
    _useState2 = _slicedToArray(_useState, 2),
    mortgagePayment = _useState2[0],
    setMortgagePayment = _useState2[1];
  var currentDTI = (mortgagePayment + debtsOut) / monthlyIncome * 100;
  var roundedCurrentDTI = Math.round(currentDTI);
  var onSliderChange = function onSliderChange(value) {
    var newMortgage = value[1] - debtsOut >= 0 ? value[1] - debtsOut : 0;
    setMortgagePayment(newMortgage);
  };
  useEffect(function () {
    setMortgagePayment(getDefaultMortgagePayment(debtsOut, monthlyIncome));
  }, [debtsOut, monthlyIncome]);
  return /*#__PURE__*/React.createElement(Spacer, {
    margin: "auto",
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement(Heading, {
    level: "4",
    marginBottom: "xs",
    "aria-live": "polite",
    "aria-atomic": "true"
  }, "Debt-to-income ratio", /*#__PURE__*/React.createElement(Text, {
    style: {
      display: 'block'
    },
    fontType: "h4",
    fontColor: roundedCurrentDTI > 50 ? 'orange500' : 'green500',
    marginBottom: "xs"
  }, Math.round(roundedCurrentDTI) + '%')), /*#__PURE__*/React.createElement(Spacer, {
    paddingBottom: "md"
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'block',
      '@media $sm_lte': {
        display: 'none'
      }
    }
  }, /*#__PURE__*/React.createElement(DTIMessage, {
    value: roundedCurrentDTI,
    defaultExpanded: true
  })), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: 'block',
      '@media $md': {
        display: 'none'
      }
    }
  }, /*#__PURE__*/React.createElement(DTIMessage, {
    value: roundedCurrentDTI
  }))), /*#__PURE__*/React.createElement(Box, {
    sx: {
      'max-width': '315px',
      margin: '$spacing.xl auto auto',
      padding: '0 $spacing.md',
      '@media $md': {
        'max-width': '500px'
      }
    }
  }, /*#__PURE__*/React.createElement(DTISlider, {
    monthlyIncome: monthlyIncome,
    debtsOut: debtsOut,
    mortgagePayment: mortgagePayment,
    inputValue: getCommaSeparatedNumber(debtsOut + mortgagePayment),
    onSliderChange: onSliderChange
  }), /*#__PURE__*/React.createElement(DTICostBreakdownTable, {
    debtsOut: debtsOut,
    monthlyIncome: monthlyIncome,
    mortgagePayment: mortgagePayment
  })));
};
var DTIOutputTable$1 = DTIOutputTable;

export { DTIOutputTable$1 as default };
